<button (click)="create()" color="primary" mat-raised-button>Starta ny</button>
